import { removeAcento } from "../RemoveAcentos";
import { onlyNumbers } from "../Masks";

export const HIGHLIGHT_STYLE: React.CSSProperties = {
    backgroundColor: '#ffc069',
    padding: 0,
};

export function findChunksText({
    searchWords,
    textToHighlight,
}: {
    searchWords: Array<string | RegExp>;
    textToHighlight: string;
    [key: string]: any;
}): Array<{ start: number; end: number }> {
    const chunks: Array<{ start: number; end: number }> = [];
    if (!textToHighlight || !searchWords || searchWords.length === 0) {
        return chunks;
    }

    const text = textToHighlight;
    const textNorm = removeAcento(text.toLowerCase());

    for (const rawWord of searchWords) {
        if (!rawWord) continue;
        const word = String(rawWord).trim();
        if (!word) continue;

        const wordNorm = removeAcento(word.toLowerCase());
        let pos = 0;
        let idx = textNorm.indexOf(wordNorm, pos);
        while (idx !== -1) {
            chunks.push({ start: idx, end: idx + wordNorm.length });
            pos = idx + 1;
            idx = textNorm.indexOf(wordNorm, pos);
        }
    }

    if (chunks.length <= 1) return chunks;

    chunks.sort((a, b) => a.start - b.start || a.end - b.end);

    const merged: Array<{ start: number; end: number }> = [];
    let cur = { ...chunks[0] };

    for (let i = 1; i < chunks.length; i++) {
        const next = chunks[i];
        if (next.start <= cur.end) {
            cur.end = Math.max(cur.end, next.end);
        } else {
            merged.push(cur);
            cur = { ...next };
        }
    }
    merged.push(cur);

    return merged;
}

export function findChunksCpfCnpj({
    searchWords,
    textToHighlight,
}: {
    searchWords: Array<string | RegExp>;
    textToHighlight: string;
    [key: string]: any;
}): Array<{ start: number; end: number }> {
    const chunks: Array<{ start: number; end: number }> = [];
    if (!textToHighlight || !searchWords || searchWords.length === 0) {
        return chunks;
    }

    const text = textToHighlight;

    for (const rawWord of searchWords) {
        if (!rawWord) continue;
        const word = String(rawWord).trim();
        if (!word) continue;

        // 1. Literal match (case & accent insensitive)
        const textNorm = removeAcento(text.toLowerCase());
        const wordNorm = removeAcento(word.toLowerCase());
        let pos = 0;
        let idx = textNorm.indexOf(wordNorm, pos);
        while (idx !== -1) {
            chunks.push({ start: idx, end: idx + wordNorm.length });
            pos = idx + 1;
            idx = textNorm.indexOf(wordNorm, pos);
        }

        // 2. Numeric sequence match across mask separators (. - /)
        const queryDigits = onlyNumbers(word);
        if (queryDigits.length > 0) {
            const digitPositions: number[] = [];
            let rawDigitsInText = '';

            for (let i = 0; i < text.length; i++) {
                const ch = text[i];
                if (ch >= '0' && ch <= '9') {
                    digitPositions.push(i);
                    rawDigitsInText += ch;
                }
            }

            let dPos = 0;
            let matchStart = rawDigitsInText.indexOf(queryDigits, dPos);
            while (matchStart !== -1) {
                const matchEnd = matchStart + queryDigits.length - 1;
                const charStart = digitPositions[matchStart];
                const charEnd = digitPositions[matchEnd] + 1;

                chunks.push({
                    start: charStart,
                    end: charEnd,
                });

                dPos = matchStart + 1;
                matchStart = rawDigitsInText.indexOf(queryDigits, dPos);
            }
        }
    }

    if (chunks.length <= 1) return chunks;

    chunks.sort((a, b) => a.start - b.start || a.end - b.end);

    const merged: Array<{ start: number; end: number }> = [];
    let cur = { ...chunks[0] };

    for (let i = 1; i < chunks.length; i++) {
        const next = chunks[i];
        if (next.start <= cur.end) {
            cur.end = Math.max(cur.end, next.end);
        } else {
            merged.push(cur);
            cur = { ...next };
        }
    }
    merged.push(cur);

    return merged;
}
